import { useEffect, useState } from 'react';
import { navLinks, siteInfo } from '@/mocks/home';

const sectionIds = navLinks.map((link) => link.href.replace('#', ''));

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [active, setActive] = useState('home');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);

      let current = sectionIds[0];
      sectionIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || mobileOpen;

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8 lg:px-12 h-16 md:h-[72px] flex items-center justify-between">
        <a
          href="#home"
          className="flex items-center gap-2.5 shrink-0 cursor-pointer"
          aria-label={`${siteInfo.name} 首页`}
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-bold text-lg">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-base md:text-lg tracking-tight transition-colors ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              {siteInfo.name}
            </span>
            <span
              className={`hidden sm:block text-[11px] mt-1 tracking-wide transition-colors ${
                solid ? 'text-foreground-500' : 'text-background-300'
              }`}
            >
              娱乐影像资料合集
            </span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = active === link.href.replace('#', '');
            return (
              <li key={link.href}>
                <a
                  href={link.href}
                  className={`px-3.5 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? solid
                        ? 'text-primary-700 bg-primary-100/70 font-medium'
                        : 'text-accent-300 bg-background-50/10 font-medium'
                      : solid
                        ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                        : 'text-background-200 hover:text-background-50 hover:bg-background-50/10'
                  }`}
                >
                  {link.label}
                </a>
              </li>
            );
          })}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-accent-500 text-background-50 text-sm font-label font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-line" aria-hidden="true"></i>
            素材投稿
          </a>
          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
              solid ? 'text-foreground-800 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
            aria-label={mobileOpen ? '关闭导航菜单' : '打开导航菜单'}
            aria-expanded={mobileOpen}
          >
            <i className={mobileOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4 max-h-[calc(100vh-4rem)] overflow-y-auto">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="block px-4 py-3 rounded-md text-base font-label text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contact"
                onClick={() => setMobileOpen(false)}
                className="mt-2 flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-accent-500 text-background-50 text-base font-label font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line" aria-hidden="true"></i>
                素材投稿
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}